<template>
  <router-view />
  <GlobalSnackbar />
</template>

<script setup>
import GlobalSnackbar from "@/components/GlobalSnackbar.vue";
</script>

<style lang="scss">
@import "@/assets/scss/all";
</style>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
